import clsx from 'clsx'

import ErrorCircle from '/react4xp/components/prototype/icons/ErrorCircle'

import type { ErrorProps } from './types'

export default function Error({ label, id, className, showIcon = true }: ErrorProps) {
	if (!label) return null

	return (
		<p role="alert" id={id} className={clsx('form-error', className)}>
			{showIcon && <ErrorCircle className="form-error-icon" />}
			{label}
		</p>
	)
}
